import * as React from "react";

import { Container } from "../semantic-ui";

const CreditsPage = () => (
  <Container text>
    <h1>Credits</h1>
    <p>
      Chess 2 Online was written by{" "}
      <a href="https://cgamesplay.com/" target="_blank" rel="noopener">
        Ryan Patterson
      </a>
      .
    </p>
    <p>
      Chess 2 is a variant of chess created by Dave Sirlin. This website is not
      affiliated with Dave Sirlin or Sirlin Games in any way.
    </p>
    <p>
      The notification sound effect came from{" "}
      <a
        href="https://freesound.org/people/YourFriendJesse/sounds/235911/"
        target="_blank"
        rel="noopener"
      >
        FreeSound user YourFriendJessie
      </a>
      .
    </p>
  </Container>
);

export default CreditsPage;
